import React from "react";
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { socket } from "./socket";
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: Infinity,
		},
	},
})
export default queryClient;

// Colecciones que el backend emite en tiempo real (`<coleccion>_created|updated|deleted`)
// y las claves de react-query que deben invalidarse al recibirlas.
export const REALTIME_QUERY_KEYS = {
	cotizacion_auto: ["cotizacion_auto"],
	poliza_auto: ["poliza_auto"],
	endoso_auto: ["endoso_auto", "poliza_auto"],
	plan_auto: ["plan_auto"],
};

const REALTIME_ACTIONS = ["created", "updated", "deleted"];

// Suscribe la vista a los eventos de socket de las colecciones indicadas e invalida sus consultas.
export function useRealtimeQueryInvalidation(collections = Object.keys(REALTIME_QUERY_KEYS)){
	const key = collections.join(",");
	React.useEffect(()=>{
		const listeners = [];
		key.split(",").filter(Boolean).forEach(collection=>{
			const queryKeys = REALTIME_QUERY_KEYS[collection] || [collection];
			REALTIME_ACTIONS.forEach(action=>{
				const event = `${collection}_${action}`;
				const handler = () => queryKeys.forEach(queryKey => queryClient.invalidateQueries(queryKey));
				socket.on(event, handler);
				listeners.push([event, handler]);
			});
		});
		return () => listeners.forEach(([event, handler]) => socket.off(event, handler));
	},[key]);
}
